import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const COOKIE_EXPIRY_PERIOD = 365 * 24 * 60 * 60 * 1000;

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieBannerDismissed = document.cookie
      .split(/;\s*/g)
      .find(row => row.trim() === 'cookieBannerDismissed=true');

    if (!cookieBannerDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    const expiryDate = new Date(Date.now() + COOKIE_EXPIRY_PERIOD);
    document.cookie = `cookieBannerDismissed=true; expires=${expiryDate.toUTCString()}; path=/`;
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Paper
      elevation={3}
      sx={{
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        p: 2,
        backgroundColor: 'rgb(241, 235, 221)',
        backdropFilter: 'blur(10px)',
        borderRadius: 2,
        maxWidth: 500,
        minWidth: 320,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        border: '1px solid rgba(0, 0, 0, 0.12)',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      }}
    >
      <Typography variant="body1" sx={{ flex: 1, color: 'text.primary', textTransform: 'none', fontSize: '0.9rem' }}>
        This site uses cookies to enhance your experience.
      </Typography>
      <IconButton
        onClick={handleDismiss}
        size="small"
        sx={{
          color: 'text.primary',
          '&:hover': {
            color: 'primary.main',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
          p: 0.5,
        }}
        aria-label="Dismiss cookie notice"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Paper>
  );
};

export default CookieBanner;
